'use strict';

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const moment=require('pulsar-utils/dist-es6/time/moment');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

TotalIncidentsDirective=class TotalIncidentsDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/statisticsPanels/totalIncidents/totalIncidentsTemplate'}
get controller(){return TotalIncidentsDirectiveController}
get objectBindings(){return[
'incidents',
'fatigueThreshold',
'deviationThreshold',
'notificationType',
'dimensions',
'interval',
'homeTimezone',
'preventAnimations',
'showNotificationType'];
}};


const MonthNames=[
'January',
'February',
'March',
'April',
'May',
'June',
'July',
'August',
'September',
'October',
'November',
'December'];


const _getMonthNameFrom=time=>MonthNames[time.getMonth()];let

TotalIncidentsDirectiveController=class TotalIncidentsDirectiveController{
constructor($scope,$timeout,dateService,timeZoneService){
this._$scope=$scope;
this._$timeout=$timeout;
this._dateService=dateService;
this._timeZoneService=timeZoneService;

if(!_.exists(this.showNotificationType)){
this.showNotificationType=!1;
}

const _redrawIfNew=(newType,oldType)=>{
if(!_.exists(newType)||newType===oldType){
return;
}

$timeout(()=>this._setupGraphViewData());
};

$scope.$watch('controller.notificationType',_redrawIfNew);
$scope.$watch('controller.incidents',_redrawIfNew);

this._setupGraphViewData();
}

_getThresholdStatusFor(incident){
return ThresholdStatus.determineFrom(
incident.fatigue,
_.get(incident.statistics,'recentHistory.fatigue'),
this.fatigueThreshold,
this.deviationThreshold,
this.notificationType);
}

_setupGraphViewData(){
const aggregateData={
Above:0,
At:0,
Below:0,
NotApplicable:0};

const monthViewData={};
const numPoints=this.incidents.length;
for(let i=0;i<numPoints;i++){
const utcMonthStart=StatisticsPanelHelpers.getUtcReferenceStartOfMonthFor(this.incidents[i].time,this.homeTimezone);

const monthName=_getMonthNameFrom(utcMonthStart);
const thresholdStatus=this._getThresholdStatusFor(this.incidents[i]);

if(!_.exists(monthViewData[monthName])){
monthViewData[monthName]={
Total:0,
Above:0,
At:0,
Below:0,
NotApplicable:0,
monthStart:utcMonthStart};

}

aggregateData[thresholdStatus.value]++;
monthViewData[monthName][thresholdStatus.value]++;
monthViewData[monthName].Total++;
}

this.graphViewData=monthViewData;
this.statusCountsForDonut=aggregateData;
this.totalIncidents=numPoints;
this.graphYAxisDomain=[0,Math.max(3,_(monthViewData).values().map(c=>c.Total).max())];
this.graphXAxisDomain=StatisticsPanelHelpers.getUtcReferenceAxisDomainFor(this.interval,this.homeTimezone);
this.subtitle=this.showNotificationType?`Alerts: ${this.notificationType.description}`:'';
}};


module.exports=TotalIncidentsDirective;
//# sourceMappingURL=totalIncidentsDirective.js.map
